import { Step } from "react-joyride";

export const lightboxTutorialSteps: Step[] = [
    // Step 0: Introduction to the Lightbox
    {
        target: ".joyride-lightbox", // Target the entire page
        content:
            "Welcome to the Lightbox! This section allows you to explore detailed information about the generated image, including its metadata, user comments, and stat generation features.",
        placement: "center",
        isFixed: false,
        disableOverlay: false,
        disableBeacon: true, // Disable the initial dot
    },
    // Step 1: Metadata Tab Introduction
    {
        target: ".joyride-metadata-tab",
        content:
            "The Metadata Tab provides detailed information about the image such as the fields you entered, art styles, themes, descriptions and more. Let's explore each part of it.",
        placement: "bottom",
        disableOverlay: false,
        isFixed: false,
    },
    // Step 2: Username Field
    {
        target: ".joyride-username",
        content:
            "This shows the username of the person who generated the image.",
        placement: "bottom",
        disableOverlay: false,
        isFixed: false,
    },
    // Step 3: Created At Field
    {
        target: ".joyride-created-at",
        content:
            "The creation date and time of the image is displayed here. It helps track when this image was generated.",
        placement: "bottom",
        isFixed: false,
        disableOverlay: false,
    },
    // Step 4: Image Type Field
    {
        target: ".joyride-image-type",
        content:
            "The type of image generation request is displayed here. It could represent a character, landscape, NPC, etc.",
        placement: "bottom",
        isFixed: false,
    },
    // Step 6: Premium Field
    {
        target: ".joyride-premium",
        content:
            "This indicates whether the image was generated using premium features, allowing for higher-quality output or advanced settings.",
        placement: "bottom",
        isFixed: false,
    },
    // Step 7: Model Information
    {
        target: ".joyride-model-info",
        content:
            "Here, you can see the technical details about the model used for generating the image, such as the CFG scale, number of steps, and sampler type. If you find an image that you think came out really cool, have a go at copying these settings in your own generations!",
        placement: "bottom",
        isFixed: false,
    },
    // Step 8: Comments Tab
    {
        target: ".joyride-comments-tab",
        content:
            "The Comments Tab allows users to leave feedback or discuss the image if it's set to public. Let other users know what you think of their CharGen's!",
        placement: "bottom",
    },
    // Step 9: Stats Tab
    {
        target: ".joyride-stats-tab",
        content:
            "In the Stats Tab, you can generate RPG stats for this image, making it useful for character, NPC, or monster creation. Stats will auto-generate based on an input CR or Level and will incorporate parts of the image for flavour! Get stats for a Green Dragon with an Icy Flavour if you generated an image with the Arctic Theme!",
        placement: "bottom",
    },
    // Step 10: Completion
    {
        target: "body",
        content:
            "You've completed the tutorial for the Lightbox! Enjoy using our platform.",
        placement: "center",
        isFixed: true,
        disableOverlay: false,
    },
];
